const url = 'plan';
import { api } from 'api';
import Swal from 'sweetalert2';
import { push } from 'react-router-redux';
import { goBack } from 'react-router-redux';
import { initialize as initializeForm } from 'redux-form';
import { createActions, handleActions } from 'redux-actions';

const EXAMEN = 1;
const PROCEDIMIENTO = 2;
const PAQUETE = 3;

const LOADER_PLAN = 'LOADER_PLAN';
const SET_DATA_PLAN = 'SET_DATA_PLAN';
const SET_PAGE_PLAN = 'SET_PAGE_PLAN';
const SET_UPDATE_DATA_PLAN = 'SET_UPDATE_DATA_PLAN';
const SET_BUSCADOR_PLAN = 'SET_BUSCADOR_PLAN';
const SET_FILTRO_PLAN = 'SET_FILTRO_PLAN';

const listar = (page = 1, tipo) =>  (dispatch, getStore) => {
    dispatch({type: LOADER_PLAN, cargando: true});
    const store = getStore();
    const search = store.plan.buscador;
    const filtro = store.plan.filtro_plan;
    let params = {page, search, tipo};
    if(filtro){
        params[''] = filtro
    }

    api.get(`${url}`, params).catch((error) => {
        dispatch({type: LOADER_PLAN, cargando: false});
        Swal(
            'Error',
            error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).then((data) => {
        if(data){
            dispatch({type: SET_DATA_PLAN, data});
            dispatch({type: SET_PAGE_PLAN, page});
        }
        dispatch({type: LOADER_PLAN, cargando: false});
    })
};

const detail = id => (dispatch, getState) =>{
    dispatch({type: LOADER_PLAN, cargando: true});
    api.get(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_PLAN, cargando: false});
    }).then((data) => {
        dispatch({type: LOADER_PLAN, cargando: false});
        if(data){
            console.log("detail: ", data);
            dispatch({type: SET_UPDATE_DATA_PLAN, updateData: data});
            dispatch(initializeForm('plan', data))
        }
    })
}

const create = (formData) => (dispatch, getStore) => {
    // const formData = getStore().form.plan.values;
    dispatch({type: LOADER_PLAN, cargando: true})

    api.post(`${url}`, formData).then((data) => {
        dispatch({type: LOADER_PLAN, cargando: false})
        Swal('Éxito', 'Se ha creado el plan.', 'success')
        .then(() => {
            if(formData.tipo_plan === EXAMEN){
                dispatch(push('/plan-examen'));
            }else if(formData.tipo_plan === PROCEDIMIENTO){
                dispatch(push('/plan-procedimiento'));
            }else if(formData.tipo_plan === PAQUETE){
                dispatch(push('/plan-paquete'));
            }
        })
    }).catch((error) => {
        dispatch({type: LOADER_PLAN, cargando: false})
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, por favor vuelva a intentar.',
            'error'
        );
    }).finally(() => {
        dispatch({type: LOADER_PLAN, cargando: false})
    });
};

const update = (formData) => (dispatch, getStore) => {
    // const formData = _.cloneDeep(getStore().form.plan.values);
    dispatch({type: LOADER_PLAN, cargando: true});
    api.put(`${url}/${formData.id}`, formData)
    .then((data) => {
        dispatch({type: LOADER_PLAN, cargando: false});
        if(data){
            Swal(
                'Éxito',
                'Datos editados correctamente.',
                'success'
            ).then(() => {
                if(formData.tipo_plan === EXAMEN){
                    dispatch(push('/plan-examen'));
                }else if(formData.tipo_plan === PROCEDIMIENTO){
                    dispatch(push('/plan-procedimiento'));
                }else if(formData.tipo_plan === PAQUETE){
                    dispatch(push('/plan-paquete'));
                }
            })
        }
    })
    .catch((error) =>{
        dispatch({type: LOADER_ROL, cargando: false});
        Swal(
            'Error',
             error.detail || 'Ha ocurrido un error, verifique los datos.',
            'error'
        )
        if(error.statusCode === 404){
            dispatch(push('/roles/create'));
        }
    })
}

const destroy = (id, extra_data) => (dispatch, getStore) => {
    console.log("data en destroy: ", extra_data);
    dispatch({type: LOADER_PLAN, cargando: true});
    api.eliminar(`${url}/${id}`).catch((error) => {
        dispatch({type: LOADER_PLAN, cargando: false});
        Swal('Error', 'No se ha logrado borrar el registro.', 'error')
            .then(() => {
                dispatch(listar(1, extra_data.tipo_plan));
            })
    }).then((data) => {
        dispatch({type: LOADER_PLAN, cargando: false});
        Swal('Éxito', 'Se ha eliminado correctamente.', 'success')
            .then(() => {
                dispatch(listar(1, extra_data.tipo_plan));
            })
    })
}

const search = (search) => (dispatch) => {
    dispatch({type: SET_BUSCADOR_PLAN, buscador: search});
    dispatch(listar(1));
};

const filtro = (filtro) => (dispatch, getStore) => {
    if (filtro == 0){
        filtro = null
    }
    dispatch({type: SET_FILTRO_PLAN, filtro_rol: filtro});
    dispatch(listar(1));
};

export const actions = {
    listar,
    create,
    update,
    detail,
    destroy,
    search,
    filtro,
};

export const reducer = {
    [LOADER_PLAN]: (state, { cargando }) => {
        return {...state, cargando }
    },
    [SET_DATA_PLAN]: (state, { data }) => {
        return {...state, data }
    },
    [SET_PAGE_PLAN]: (state, { page }) => {
        return {...state, page }
    },
    [SET_UPDATE_DATA_PLAN]: (state, { updateData }) => {
        return {...state, updateData }
    },
    [SET_BUSCADOR_PLAN]: (state, { buscador }) => {
        return {...state, buscador }
    },
    [SET_FILTRO_PLAN]: (state, { filtro_plan }) => {
        return {...state, filtro_plan }
    },
};

export const initialState = {
    cargando: false,
    page: 1,
    data: {
        count: 0,
        next: null,
        previous: null,
        results: [],
    },
    buscador: '',
    filtro_plan: null,
    updateData: {},
};

export default handleActions(reducer, initialState)
